import { Logger } from '@frontend/logger';
import { DocType } from '@frontend/repository';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LuFile, LuX } from 'react-icons/lu';
import useDropZone from './drop-zone.controller';

export interface DropZoneProps {
    dropZoneMessage?: React.ReactNode;
    enableImportButton?: boolean;
    importButtonLabel?: React.ReactNode;
    onChange: (file: File | null | undefined) => void;
    file: File | null | undefined;
    type?: DocType | DocType[] | string | string[];
    onUpload?: (file: File) => void;
}

export const DropZone = (props: DropZoneProps) => {
    const viewProps = useDropZone(props);
    Logger.log(props.file);
    if (props.file) {
        return (
            <div className='card card-body border card-plain border-radius-lg d-flex align-items-center flex-row justify-content-between'>
                <div className='d-flex justify-content-start align-items-center'>
                    {props.file.type.includes('image') ? (
                        <img
                            src={URL.createObjectURL(props.file)}
                            alt='file'
                            className='h-[300px] aspect-auto object-contain ms-2'
                        />
                    ) : (
                        <>
                            <LuFile className='me-2' />
                            <span className='font-weight-bolder'>{props.file.name}</span>
                        </>
                    )}
                </div>

                <LuX
                    data-testid="delete-button"
                    className='cursor-pointer'
                    onClick={() => props.onChange(undefined)}
                />
            </div>
        );
    }
    return (
        <div
            ref={viewProps.dropZoneRef}
            className={`flex flex-col justify-center items-center w-full h-40 border-dashed border-1 border-secondary ${
                viewProps.isDropping ? 'bg-light' : ''
            }`}>
            <span className='font-semibold'>
                {props.dropZoneMessage ? (
                    props.dropZoneMessage
                ) : (
                    <FormattedMessage
                        id='DropZone.DropZoneMessage'
                        description='Dropzone message'
                        defaultMessage='Drop a file here'
                    />
                )}
            </span>
            {props.enableImportButton && (
                <label
                    htmlFor='file-input'
                    className='btn btn-brand-primary'>
                    <input
                        type='file'
                        id='file-input'
                        className='hidden text-white'
                        accept={viewProps.accept}
                        onChange={(e) => props.onChange(e.target.files?.[0])}
                    />
                    <span className='text-white'>{props.importButtonLabel}</span>
                </label>
            )}
            <div className='d-flex flex-column justify-content-center'>
                <span className='font-semibold text-xs'>
                    <FormattedMessage
                        id='DropZone.AllowedTypes'
                        description='Label for the allowed file types'
                        defaultMessage='Allowed types'
                    />
                </span>
                <span className='text-xs text-primary'>{viewProps.allowedTypes}</span>
            </div>
            {viewProps.error && <div className='flex flex-row justify-center bg-danger text-white p-2 rounded text-xs'>{viewProps.error}</div>}
        </div>
    );
};
